import React from 'react'
import DashboardLinks from '../components/Navigation/DashboardLinks'
import Subtitle from '../components/UI/Subtitle'
import { FormattedMessage } from "react-intl"
import DatasheetList from '../components/DatasheetList'

const Datasheets = () => {
    return (
        <>
            <DashboardLinks />
            <div className="p-4">
                <Subtitle><FormattedMessage id="app.privateMenu.datasheets" defaultMessage="Datasheets" />:</Subtitle>
                <hr className='mt-4 mb-4'></hr>
                <DatasheetList />
            </div>
        </>
    )
}

export default Datasheets